<template>
  <div class="slider-main" v-if="$store.state.slider && $store.state.slider.length > 0">
    <div class="slider-main-wrapper">
      <div title="Влево" @click.prevent="swiper.slidePrev()" class="slider-control-button">
        <arrow-left />
      </div>
      <div title="Вправо" @click.prevent="swiper.slideNext()" class="slider-control-button right">
        <arrow-right />
      </div>
      <swiper ref="swiper" :options="options">
        <swiper-slide v-for="(slide, index) in slider" :key="index">
          <a
            :href="slide.href | url"
            target="_blank"
            class="slider-main-item"
            :title="slide.title"
          >
            <img
              :alt="slide.title" :src="getImg(slide)"
              :title="slide.title" loading="lazy"
              class="slider-main-image"
              itemprop="image"
            >
            <!--        <object :data="getImg(slide)" class="slider-main-image" type="image/jpg">-->
            <!--          <img :alt="slide.title" src="/public/img/icons/picture.png" style="width: 100%; height: 100%; object-fit: contain; object-position: center"/>-->
            <!--        </object>-->
          </a>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import ArrowRight from 'components/svg/ArrowRight.vue'
import ArrowLeft from 'components/svg/ArrowLeft.vue'

export default {
  name: 'MainSlider',
  components: {
    Swiper,
    SwiperSlide,
    ArrowLeft,
    ArrowRight
  },
  directives: {
    swiper: directive
  },
  data () {
    return {
      options: {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        clickable: true,
        speed: 800,
        breakpoints: {
          460: {
            slidesPerView: 1.2
          },
          560: {
            slidesPerView: 1.5
          },
          700: {
            slidesPerView: 2
          },
          990: {
            slidesPerView: 2.5
          },
          1100: {
            slidesPerView: 3
          }
        }
      }
    }
  },
  computed: {
    slider () {
      return this.$store.state.slider
    },
    swiper () {
      return this.$refs.swiper.$swiper
    }
  },
  methods: {
    /**
       * Получение картинки в зависимости есть они или нет и
       * с медиасервера она или с бэкенда
       * @param item - элемент откуда получаю изображение
       */
    getImg (item) {
      if (item.img_slides.length > 0) {
        if (item.img_slides[0].get_img.media_server_url !== null) {
          return item.img_slides[0].get_img.media_server_url + item.img_slides[0].get_img.url
        } else {
          return this.$store.state.system_data.base_url + '/' + item.img_slides[0].get_img.url
        }
      } else {
        return '/public/img/placeholder.png'
      }
    }
  }
}
</script>
